import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "downloadSurveyButtonContent px-4 py-1.5" }
const _hoisted_2 = { class: "label text-sm font-medium" }
const _hoisted_3 = { class: "icon flex" }

import { IonSpinner, IonIcon } from '@ionic/vue'
import { arrowDownCircleOutline } from "ionicons/icons"
import { useI18n } from 'vue-i18n';

//Emits

export default /*#__PURE__*/_defineComponent({
  __name: 'DownloadSurveyButton',
  props: {
  isDownloading: { type: Boolean, required: false }
},
  emits: ['onClick'],
  setup(__props, { emit }) {

const props = __props;



//Props


//Variables
const { t } = useI18n({ useScope: 'global' })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "downloadSurveyButton",
    onClick: _cache[0] || (_cache[0] = ($event: any) => {$event.stopPropagation(); emit('onClick')})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('downloadSurveyButton.download')), 1),
      _createElementVNode("div", _hoisted_3, [
        (props.isDownloading)
          ? (_openBlock(), _createBlock(_unref(IonSpinner), {
              key: 0,
              name: "circular",
              color: "light"
            }))
          : (_openBlock(), _createBlock(_unref(IonIcon), {
              key: 1,
              class: "md icon-small",
              icon: _unref(arrowDownCircleOutline)
            }, null, 8, ["icon"]))
      ])
    ])
  ]))
}
}

})